module.exports = __webpack_public_path__ + "img/msc_seminar_heddar.6ec1532a.jpg";